// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".city-owner .dialog-content-item {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  line-height: 34px;\n  padding: 20px;\n}\n.city-owner .dialog-content-item .city-select {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.city-owner .dialog-content-item .data-select {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n", ""]);
// Exports
module.exports = exports;
